import * as React from 'react';
import { InputAdornment } from 'components/Form';
import { PlayButtonCircle } from 'components/icons';
import Tooltip from 'components/Tooltip';

function ClipEndTimeInputAdornment(
  props: React.ComponentPropsWithoutRef<typeof InputAdornment>,
) {
  return (
    <Tooltip
      content="Preview last 5 seconds"
      id="end-time-tooltip"
      placement="top"
    >
      <InputAdornment {...props}>
        <PlayButtonCircle />
      </InputAdornment>
    </Tooltip>
  );
}

export default ClipEndTimeInputAdornment;
